import { useEffect, useState } from "react";
import Markdown from "react-markdown";

import { aiSummaryContent } from "@/mocks/apis/summary/data";

const ChunkSkeleton = () => {
  return (
    <div
      data-testid="paragraph-skeleton"
      className="mt-3 animate-pulse space-y-1"
    >
      <div className="h-5 bg-whisper rounded w-full" />
      <div className="grid grid-cols-3 gap-1">
        <div className="h-5 bg-whisper rounded w-full" />
        <div className="h-5 bg-whisper rounded w-full" />
        <div className="h-5 bg-whisper rounded w-full" />
      </div>
      <div className="grid grid-cols-2 gap-1">
        <div className="h-5 bg-whisper rounded w-full" />
        <div className="h-5 bg-whisper rounded w-full" />
      </div>
      <div className="h-5 bg-whisper rounded w-2/3" />
    </div>
  );
};

export const AISummary = () => {
  const [chunks, setChunks] = useState<string[]>([]);
  const [isStreaming, setIsStreaming] = useState(true);

  useEffect(() => {
    const lines = aiSummaryContent.split("\n");
    if (lines.length === 0) {
      setIsStreaming(false);
      setChunks([]);
      return;
    }

    let i = 0;

    const tick = () => {
      if (i >= lines.length) {
        clearInterval(intervalId);
        setIsStreaming(false);
        return;
      }
      setChunks((prev) => [...prev, lines[i]]);
      i++;
    };

    // push first item immediately
    tick();

    const intervalId = setInterval(tick, 100);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="p-2 mx-5 markdown-ai-summary">
      <Markdown>{chunks.join("\n")}</Markdown>
      {isStreaming && <ChunkSkeleton />}
    </div>
  );
};
